import React from "react";
import ReactDOM from "react-dom";
import { devices } from "./devices";
import { formDevice } from "./heatmeterProcessor";
import "./heatmeters.css";

class Heatmeters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.handlerShrink = this.handlerShrink.bind(this);
    }

    handleContent(id) {
        const paragraphs = ReactDOM.findDOMNode(this).getElementsByClassName(
            "heatmeters_display"
        );

        const paragraphContainer = ReactDOM.findDOMNode(this).getElementsByClassName(id)[0];

        if(paragraphContainer.className === id){
            paragraphContainer.className += " preview"
        }
        else{
            paragraphContainer.className = id;
        }
        
        const fullClass = "heatmeters_display";
        const shortClass = "heatmeters_display heatmeters_hide";

        for (var i = 0; i < paragraphs.length; i++) {
            if (paragraphs[i].attributes.artid.value === id) {
                if (paragraphs[i].className === shortClass) {
                    paragraphs[i].className = fullClass;
                } else {
                    if (paragraphs[i].attributes.role.value !== "preview")
                        paragraphs[i].className = shortClass;
                }
            }
        }
    }

    handleButton(id) {
        const buttons = ReactDOM.findDOMNode(this).getElementsByClassName(
            "theButton"
        );

        for (var i = 0; i < buttons.length; i++) {
            if (buttons[i].attributes.heatmeterid.value === id) {
                if (buttons[i].attributes.active.value === "true") {
                    buttons[i].attributes.active.value = "false";
                    buttons[i].className = "theButton hiddenButton";
                } else {
                    buttons[i].attributes.active.value = "true";
                    buttons[i].className = "theButton";
                }
            }
        }
    }

    handlerShrink(id) {
        const deviceIdDiv = "div" + id;
        const deviceIdButton = "button" + id;

        this.handleContent(deviceIdDiv);
        this.handleButton(deviceIdButton);
    }

    render() {
        let devicesHTML = [];

        devices.map((value, index) => {
            const image = (
                <img
                    src={window.location.origin + value.image}
                />
            );

            const meterTypeHTML = (
                <center>
                <div className="meterTypeHeader" id={value.routid}>
                    {image}
                    <div>{value.meterType}</div>
                    </div>
                    </center>
            );

            devicesHTML.push(meterTypeHTML);

            value.meters.map((value, index) => {
                const deviceHTML = formDevice(value, this.handlerShrink, this.props.showModal);
                devicesHTML.push(deviceHTML);
                devicesHTML.push(<br />);
                devicesHTML.push(<br />);
            });
        });

        return <div className="devicesContainer">{devicesHTML}</div>;
    }
}

export default Heatmeters;
